import DeptTypes from '../types/DepartmentTypes';

const initialState = {
  isLoading: false,
  listData: [],
  itemData: {},
  activeDeptData: [],
  queryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: ''
  }
};

// eslint-disable-next-line default-param-last
const department = (state = initialState, action) => {
  switch (action.type) {
    case DeptTypes.GET_DEPARTMENT_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DeptTypes.GET_DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        listData: action.payload
      };
    case DeptTypes.GET_DEPARTMENT_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        listData: []
      };

    case DeptTypes.GET_DEPARTMENT_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DeptTypes.GET_DEPARTMENT_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        itemData: action.payload
      };
    case DeptTypes.GET_DEPARTMENT_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        itemData: []
      };

    case DeptTypes.GET_DEPARTMENT_ACTIVE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DeptTypes.GET_DEPARTMENT_ACTIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activeDeptData: action.payload
      };
    case DeptTypes.GET_DEPARTMENT_ACTIVE_ERROR:
      return {
        ...state,
        isLoading: false,
        activeDeptData: []
      };
    case DeptTypes.UPDATE_QUERY_PARAMS:
      return {
        ...state,
        queryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paginationModel,
          sortingData: action.payload.sortInfo,
          keyword: action.payload.keyword
        }
      };

    default:
      return state;
  }
};
export default department;
